export default __webpack_public_path__ + "static/media/Optimized-pexels-sora-shimazaki-5669619.33e4c5d6.jpg";